import { apiSlice } from '../../../app/services/apiSlice';

const VENDORS_URL1 = 'vendor/api';

export const publicPagesAPISlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPreviewThemesLink: builder.query({
      query: () => ({
        url: `${VENDORS_URL1}/settings/template/public/website/predefined`,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData;
      },
    }),
    postInquiry: builder.mutation({
      query: ({ body }) => ({
        url: '/authentication/auth/public/website/register-demo-inquiry',
        method: 'POST',
        body: body,
      }),

      transformResponse: (responseData) => {
        return responseData?.objectData;
      },
    }),
    verifyCaptcha: builder.mutation({
      query: (params) => ({
        url: '/authentication/auth/validate-recaptcha',
        method: 'POST',
        params: params,
        responseHandler: (response) => response.text(),
      }),
      transformResponse: (responseData) => {
        return responseData;
      },
    }),
  }),
});

export const {
  useGetPreviewThemesLinkQuery,
  usePostInquiryMutation,
  useVerifyCaptchaMutation,
} = publicPagesAPISlice;
